const SET_DISPLAY_TYPE = (state, type) => {
    state.displayType = type;
}
const SET_Y_OFFSET = (state, offset) => {
    state.offsetY = offset;
}
const SET_WINDOW_WIDTH = (state, width) => {
    state.windowWidth = width;
}
const SET_WINDOW_HEIGHT = (state, height) => {
    state.windowHeight = height;
}
const CHANGE_NAV_VISIBILITY = (state, visible) => {
    state.navVisible = visible;
}
const HIDE_NAV = (state) => {
    state.navVisible = false;
}
const HIDE_COOKIE = (state) => {
    state.showCookie = false;
}
const CHANGE_CONTACT_FORM_STATUS = (state,status) => {
    state.contactFormAvailable = status;
}

export default {
    SET_DISPLAY_TYPE,
    SET_Y_OFFSET,
    SET_WINDOW_WIDTH,
    SET_WINDOW_HEIGHT,
    CHANGE_NAV_VISIBILITY,
    HIDE_NAV,
    HIDE_COOKIE,
    CHANGE_CONTACT_FORM_STATUS
}


// WEBPACK FOOTER //
// ./src/store/system/mutations.js